<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">邀请记录</span>
        </template>
    </NavBar>
    <Poster @ready="posterReady"></Poster>
    <div class="entrance" v-if="entrance" :class="{xinhua: xinhua}">
        <div class="button" @click="entrance = false">邀请记录</div>
        <div class="poster" v-if="posterBase64">
            <img :src="posterBase64">
        </div>
        <template v-if="wechat || xinhua">
            <p class="text">分享到</p>
            <div class="action">
                <div class="item" @click="share(1)">
                    <img src="@/assets/images/wechat.png">
                    <p>微信</p>
                </div>
                <div class="item" @click="share(3)">
                    <img src="@/assets/images/friends.png">
                    <p>朋友圈</p>
                </div>
                <div class="item" id="copy" @click="copy" :data-clipboard-text="url">
                    <img src="@/assets/images/copy-link.png">
                    <p>复制链接</p>
                </div>
                <div class="item" @click="download" v-if="xinhua">
                    <img src="@/assets/images/save.png">
                    <p>保存图片</p>
                </div>
            </div>
            <van-overlay :show="shareShow" class="share-guide" @click="shareShow = false">
                <img src="@/assets/images/guide-arrow.png" alt="">
                <div class="tip">
                    <p class="title">立即分享给好友吧</p>
                    <p class="subtitle">点击屏幕右上角将本页面分享给好友</p>
                </div>
            </van-overlay>
        </template>
    </div>
    <template v-else>
        <div class="tab">
            <div class="item" :class="{active: selected == 'success'}" @click="changeTab('success')">邀请成功</div>
            <div class="item" :class="{active: selected == 'fail'}" @click="changeTab('fail')">邀请失败</div>
        </div>
        <div class="list" v-if="invitations.length" @scroll="scroll">
            <div class="item" v-for="(invitation, index) in invitations" :key="index">
                <p class="situation">{{ invitation.situation }}</p>
                <div class="bottom">
                    <p class="date">{{ invitation.date }}</p>
                    <p class="reward">{{ invitation.reward }}</p>
                </div>
            </div>
        </div>
        <img src="@/assets/images/empty.png" class="empty" v-else>
    </template>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>